
import { Splide, SplideSlide } from "@splidejs/react-splide";
import banner1 from "../../assets/images/urban/banner-1.jpg";
import banner2 from "../../assets/images/urban/banner-2.JPG";
import banner3 from "../../assets/images/urban/banner-3.jpg";
import "@splidejs/react-splide/css";
const Banner = () => {
  const images = [banner1, banner2, banner3];
  return (
    <div>
      <Splide
        aria-label="My Favorite Images"
        options={{
          rewind: true, // If you want the slider to go back to the first slide after the last slide.

          arrows: false, // Hides the navigation arrows.
          autoplay: true, // Enables autoplay mode.
          interval: 3000, // Interval between each slide transition (in milliseconds).
          loop: true, // Enables infinite looping.
          type: "loop", // Sets the slider type to loop mode for continuous rotation
          direction: "ltr",
          pauseOnHover: false, // Optional: Prevents autoplay from pausing when hovering.
          pauseOnFocus: false, // Optional: Prevents autoplay from pausing when the slider gains focus.
        }}
      >
        {images.map((img, idx) => {
          return (
            <SplideSlide key={idx}>
              <div className="aspect-video">
                <img
                  src={img}
                  alt="Image 1"
                  className="w-full h-full object-cover"
                />
              </div>
            </SplideSlide>
          );
        })}
      </Splide>
    </div>
  );
};

export default Banner;

// <div className="mx-auto h-[35vh] lg:h-auto lg:max-h-[60vh]relative overflow-hidden relative text-center  ">
//       <img
//         src={bannerImg}
//         alt="Urban banner image"
//         className=" w-full h-full  object-cover "
//       />
//     </div>
